import type { ReactElement, ReactNode } from "react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { FeedbackStatusIcon } from "@/lib/feedbackVariants";
import { cn } from "@/lib/utils";

export type StatusAlertVariant = "info" | "warning" | "error";

const alertVariantByStatus: Record<StatusAlertVariant, "info" | "warning" | "destructive"> = {
  info: "info",
  warning: "warning",
  error: "destructive",
};

type StatusAlertProps = {
  variant: StatusAlertVariant;
  title?: string;
  children: ReactNode;
  className?: string;
};

/** Inline alert with status icon — use for info, warning, and error messages. */
export function StatusAlert({
  variant,
  title,
  children,
  className,
}: StatusAlertProps): ReactElement {
  return (
    <Alert variant={alertVariantByStatus[variant]} className={cn(className)}>
      <FeedbackStatusIcon variant={variant} />
      {title ? <AlertTitle>{title}</AlertTitle> : null}
      <AlertDescription>{children}</AlertDescription>
    </Alert>
  );
}
